import {cs} from "./chain-services";
import {Static2} from "./static-2";
import {fragments} from "./fragments";
import {Invoke} from "./invoke";
import {OnUnmounted} from "./on-unmounted";

export const BlockWindowUnload = ({}) => cs(
    ["unmount", (_, next) => Static2({next})],
    ({unmount}) => fragments(
        Invoke({
            action: () => {
                const listener = e => {
                    e.returnValue = "Are you sure you want to leave?";
                };
                window.addEventListener("beforeunload", listener);

                unmount.set(() => window.removeEventListener("beforeunload", listener));
            },
        }),
        OnUnmounted({
            action: () => unmount.get()?.(),
        })
    ),
);
